import {SET_BOARD_STYLES} from "../../constants";

const initialState = {
    boardStyle: []
}
export const BoardStyleReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_BOARD_STYLES:
            return {
                ...state,
                boardStyle: action.payload
            }
        default:
            return state;
    }
}